

export namespace UiAvatar {
    export interface Component {
        /**
         * Expects url of the avatar img
         * @type {string}
         * @memberof Component
         */
        avatar: string;
        /**
         * Profile name
         * @type {string}
         * @memberof Component
         */
        name: string;

        /**
         * How many letters to use.
         * Initial is 2
         * @type {number}
         * @memberof Component
         */
        initials: number;

        /**
         * Shape of the avatar
         * @type {Shape}
         * @memberof Component
         */
        shape: Shape; // circle / square / squircle
        /**
         * Initial is 48
         * @type {number}
         * @memberof Component
         */
        size: number;
        /**
         * Initial is '70%'
         * @type {string}
         * @memberof Component
         */
        iconSize: string;
        /**
         * If bg (color) is set, the icon will not have a border
         * @type {string}
         * @memberof Component
         */
        bg: string;

        /**
         * Initial 'inherit'
         * @type {string}
         * @memberof Component
         */
        color: string;
        /**
         *
         * @type {boolean}
         * @memberof Component
         */
        animated: boolean;
        /**
         *
         * @type {string}
         * @memberof Component
         */
        icon: string;
        /**
         * Initial is '1rem'
         * @type {string}
         * @memberof Component
         */
        fontSize: string;
    }

    export enum Shape {
        CIRCLE = 'circle',
        SQUARE = 'square',
        SQUIRCLE = 'squircle'
    }

    export const defaultProp = {
        initials: 2,
        size: 48,
        shape: Shape.CIRCLE,
        color: 'inherit',
        icon: 'profile',
        iconSize: '70%',
        fontSize: '1rem',
        animated: true
    }
    Object.freeze(defaultProp);
}